import React, { useEffect } from 'react';

import Heading from '../components/Headers/Heading';
import AboutText from '../components/AboutComponents/AboutText';
import TextContent from '../components/TextContent/TextContent';
import TeamSection from '../components/AboutComponents/TeamSection';
import Art from '../components/Misc/Art';
import illustration from '../assets/images/art_1.png';
import AccoladesSection from "../components/AboutComponents/AccoladesSection";
import CultureContent from '../components/TextContent/CultureContent';
import PressSection from '../components/AboutComponents/PressSection';
import Seo from '../components/Misc/Seo';
import aboutHeaderImage from '../assets/images/about-header.jpg';
import aboutFooterImage from '../assets/images/services-footer1.jpg';
import aboutImage0 from '../assets/images/about-0.jpg';
import aboutImage1 from '../assets/images/about-1.jpg';

function About() {
    const canonical = 'https://studio.norcat.org/About';
    const title = 'About Studio NORCAT | A Studio driven by experiences that matter.';
    const description =
        'Meet the multidisciplinary team behind Studio NORCAT and learn how we design immersive, applied solutions for learning, training, and workforce development.';

    useEffect(() => {
        document.body.classList.add('about-page-view');

        return () => {
            document.body.classList.remove('about-page-view');
        };
    }, []);

    return (
        <div className="about-page">
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${aboutHeaderImage}`}
                ogImageAlt="Studio NORCAT team and studio environment"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${aboutHeaderImage}`}
                twitterImageAlt="Studio NORCAT team and studio environment"
            />
            <div className="page-header position-relative">
                <Heading
                    heading={<h1>About Us</h1>}
                    headingClass="heading-very-large dark-1"
                    paragraph="We design and build technical solutions to address challenges in learning and training environments."
                    paragraphClass="dark-2"
                    WrapperComponent={(props) => {
                        return (
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        )
                    }}
                />

                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={aboutHeaderImage} alt="Studio NORCAT team collaborating in Studio NORCAT's Motion Capture Volume" />
                    </div>
                    <Art art={illustration} type="1" />
                </div>
            </div>
            <AboutText content="We believe the best ideas come from building together—experimenting, adapting, and learning through collaboration to create solutions shaped by real use and built to matter." />
             <CultureContent /><br/><br/>
               <div className="single-image-wrapper">
                <div className="single-image">
                    <img src={aboutImage0} alt="Studio NORCAT team member testing our VR programs" />
                </div>
                <div className="single-image">
                    <img src={aboutImage1} alt="Studio NORCAT team recording animations for Virtual Reality" />
                </div>
            </div><br /><br />
            <TextContent />
            <AccoladesSection />
            <TeamSection />

            <div className="page-header-bottom">
                <div className="single-image">
                    <img src={aboutFooterImage} alt="A section of the Studio NORCAT team and studio environment" />
                </div>
                <Art art={illustration} type="1" />
            </div>
            <PressSection />
        </div>
    );
}

export default About;
